import { AddressField, AddressFieldConfiguration } from '@marketplace-web/address/address-data'

import { settingsUserInputEvent } from '_libs/common/event-tracker/events'
import { Screen } from 'constants/tracking/screens'

const addressFieldConfig: Array<AddressFieldConfiguration> = [
  {
    field: AddressField.Name,
    required: true,
  },
  {
    field: AddressField.Country,
  },
  {
    field: AddressField.Line1,
    required: true,
  },
  {
    field: AddressField.Line2,
  },
  {
    field: AddressField.PostalCode,
    required: true,
  },
  {
    field: AddressField.City,
    required: true,
  },
]

export const addressFieldConfiguration = addressFieldConfig.map(field => {
  return {
    field: field.field,
    required: field.required,
    trackingEvent: settingsUserInputEvent({
      screen: Screen.GetShippingLabel,
      target: field.field,
      isValid: true,
    }),
  }
})

export default addressFieldConfiguration
